import React from 'react'

import { RowFlexDiv } from './CommonStyle'
import { NudistaMedium12 } from '../Common/Fonts'

const Notification = ({ marginLeft, marginTop }) => {
  return (
    <RowFlexDiv
      borderRadius='50%'
      marginTop='2px'
      width='15px'
      height='17px'
      backgroundColor='#FF5252'
      outline='3px solid #ffffff'
      justifyContent='center'
      boxShadow='3px 3px 6px 3px rgba(0, 0, 0, 0.3)'

      // position='absolute'
      // zIndex='9111'
    >
      <NudistaMedium12 white>2</NudistaMedium12>
    </RowFlexDiv>
  )
}

export default Notification
